import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AdminUser } from '@reflact/ipkv-types/dist/Admin';
import { User } from '../services/user';

export const nutzerResolver: ResolveFn<AdminUser[]> = async (route, state) => {
  const userService = inject(User);
  return await userService.getUsers();
};
